import * as THREE from 'three';
import React, { useMemo } from 'react';
import { params } from '../../../../../../redux/reducers/reducer';
import { extrudeSettings } from '../../../../../../utils/Functions';
import HandleOneModel from '../../../ShareModel/HandleModel/HandleOneModel';

const DiamondWindowWalkInDoor = ({ width, height, trimWidth, doorColor, glassTexture, handlePlacement, handleModel }) => {
    const trimColor = useMemo(() => {

        return params.p_t_c.replace('0x', '#');
    }, [params.p_t_c])

    const trimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-(width / 2 - trimWidth),  -height / 2);
        model.lineTo(-width / 2,  -height / 2);
        model.lineTo(-width / 2,  height / 2);
        model.lineTo(width / 2,  height / 2);
        model.lineTo(width / 2,  -height / 2);
        model.lineTo(width / 2 - trimWidth,  -height / 2);
        model.lineTo(width / 2 - trimWidth,  height / 2 - trimWidth);
        model.lineTo(-(width / 2 - trimWidth),  height / 2 - trimWidth);
        model.closePath();

        return model;
    }, [width, height, trimWidth])

    const doorModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-(width / 2 - 0.03 - trimWidth),  -(height / 2 - 0.03));
        model.lineTo(-(width / 2 - 0.03 - trimWidth),  height / 2 - trimWidth);
        model.lineTo(width / 2 - 0.03 - trimWidth,  height / 2 - trimWidth);
        model.lineTo(width / 2 - 0.03 - trimWidth,  -(height / 2 - 0.03));
        model.closePath();

        const hole = new THREE.Path();
        hole.moveTo(0, height / 2 - trimWidth - height / 15);
        hole.lineTo(-(width / 2) / 5 * 2, height / 2 - trimWidth - height / 15 - (width / 2) / 5 * 2);
        hole.lineTo(0, height / 2 - trimWidth - height / 15 - (width / 5 * 2));
        hole.lineTo((width / 2) / 5 * 2, height / 2 - trimWidth - height / 15 - (width / 2) / 5 * 2);
        hole.closePath();

        model.holes.push(hole);

        return model;
    }, [width, height, trimWidth])
    
    const glassModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-(width / 2) / 5 * 2, height / 2 - trimWidth - height / 15 - (width / 2) / 5 * 2);
        model.lineTo(0, height / 2 - trimWidth - height / 15);
        model.lineTo((width / 2) / 5 * 2, height / 2 - trimWidth - height / 15 - (width / 2) / 5 * 2);
        model.lineTo(0, height / 2 - trimWidth - height / 15 - (width / 5 * 2));
        model.closePath();

        return model;
    }, [width, height, trimWidth])

    return (
        <>
            <mesh name='trim'>
                <extrudeGeometry args={[trimModel, extrudeSettings(0.3)]} />
                <meshStandardMaterial side={THREE.DoubleSide} color={trimColor} roughness={0.5} metalness={0.2} emissive={'#101010'} toneMapped={false} />
            </mesh>
            <mesh name='glass-door' position={[0, 0, 0.05]}>
                <extrudeGeometry args={[doorModel, extrudeSettings(0.2, 0.03, 0.03, 0, 2)]} />
                <meshStandardMaterial  color={doorColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} />
            </mesh>
            <mesh name='glass' position={[0, 0, 0.05]}>
                <extrudeGeometry args={[glassModel, extrudeSettings(0.2)]} />
                <meshPhongMaterial envMap={glassTexture} side={THREE.DoubleSide} reflectivity={1} />
            </mesh>

            <HandleOneModel handlePlacement={handlePlacement} width={width} handleModel={handleModel} />
        </>
    )
}

export default DiamondWindowWalkInDoor